import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import classes from './mergeModalContent.module.scss';
import Button from '../../../_common/Form/Buttons/Button';
import { getPatientsRequest } from '../../../../store/actions/patients';
import Utils from '../../../../utils/utils';
import Api from '../../../../api/api';
import accountHelpers from '../../../../utils/accountHelpers';

const allowTypes = '.xlsx, .xlsm, .xls, .xlt, .csv';

const exampleFileUrl = 'https://sortpak.s3.us-west-1.amazonaws.com/patients/Patients.xlsx';

const UploadBulkModalContent = ({ onCancel, filters }) => {
  const dispatch = useDispatch();

  const [uploadingFile, setUploadingFile] = useState(null);
  const [error, setError] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const uploadFile = (e) => {
    Utils.onUploadFile(e, (file) => {
      setUploadingFile(file);

      setError(false);
    }, allowTypes);
  };

  const save = async () => {
    setSaveLoading(true);

    if (!uploadingFile) {
      setError(true);

      toast.error('Please upload file');
    } else {
      try {
        const { data } = await Api.bulkCreatePatient({
          userId: accountHelpers.getUser().id,
          file: uploadingFile,
        });

        await dispatch(getPatientsRequest(filters));

        toast.success(data.message);

        onCancel();
      } catch (e) {
        toast.error(e.response?.data?.message || 'Wrong file data');

        setError(true);
      }
    }
    setSaveLoading(false);
  };

  return (
    <div className={classes.wrapper}>
      <h2>Patient Bulk Upload</h2>

      <div className={classes.upload_field_wrapper}>
        <label htmlFor="addXLSX" className={`${classes.upload_field} ${error ? classes.error : ''}`}>
          <input
            type="file"
            id="addXLSX"
            accept={allowTypes}
            onChange={uploadFile}
          />

          <p>
            {uploadingFile?.name || 'Add XLS or CSV file'}
          </p>
        </label>
      </div>

      <a
        href={exampleFileUrl}
        className={classes.file_example_wrapper}
        download
      >
        Download file example
      </a>

      <div className={classes.save_btns_wrapper}>
        <Button
          title="Cancel"
          type="button"
          clearButton
          onClick={onCancel}
        />

        <Button
          title="Upload"
          type="button"
          reverseColor
          onClick={save}
          loading={saveLoading}
        />
      </div>
    </div>
  );
};

UploadBulkModalContent.propTypes = {

};

export default UploadBulkModalContent;
